import {
  ReportingResponsesConversionData,
  ReportingResponsesFinancialMovementData,
} from '@genial/services/dist/models';
import { capitalize } from 'lodash';

export const mountChartMobileLegend = (
  data: ReportingResponsesConversionData[] | ReportingResponsesFinancialMovementData[] | undefined
) => {
  const getCapitalizedMonth = (
    month?:
      | ReportingResponsesConversionData['monthAcronym']
      | ReportingResponsesFinancialMovementData['monthAcronym']
  ) => {
    if (!month) {
      return '';
    }
    return capitalize(month);
  };

  if (!data || data.length < 2) {
    return '';
  }
  const { monthAcronym: firstMonthAcronym } = data[0];
  const { monthAcronym: lastMonthAcronym } = data[data.length - 1];

  return `${getCapitalizedMonth(firstMonthAcronym)} até ${getCapitalizedMonth(lastMonthAcronym)}`;
};
